import { useEffect, useState } from "react";
import { getChromeVersion, getTizenVersion } from "../../../../../shared-logic/features/retailer/utils/utils";

/**
 * Checks if there is decent WebGL support
 * - 0 = No support
 * - 1 = Experimental support (IE11)
 * - 2 = Full WebGL support
 */
const useWebGLSupportLevel = (): 0 | 1 | 2 => {
    const [supportLevel, setSupportLevel] = useState(2); // default is 2 as most browsers fully support webGL

    useEffect(() => {
        // ancient chrome versions (used in retailer applications) don't support object spreading syntax, which are used in the compiled three.js bundles
        const chromeVersion = getChromeVersion(); // will return undefined if not chrome
        if (chromeVersion && chromeVersion < 70) {
            setSupportLevel(0);
            return;
        }

        // TizenOS (Adobe screens) uses Chrome, but for some reason does not mention this in the useragent string (Tizen OS 5.5 uses Chrome v69)
        // https://developer.samsung.com/smarttv/develop/specifications/web-engine-specifications.html
        const tizenVersion = getTizenVersion(); // will return undefined if not Tizen OS
        if (tizenVersion && tizenVersion < 5) {
            setSupportLevel(0);
            return;
        }

        const tempCanvas = document.createElement("canvas");
        let context = tempCanvas.getContext("webgl");
        if (!context) {
            context = tempCanvas.getContext("experimental-webgl") as any; // In IE11 you need to use "experimental-webgl" to access webgl v0.94
            setSupportLevel(context ? 1 : 0);
        }
    }, []); // useEffect is needed so we can check on the client device instead during server side render

    return supportLevel as 0 | 1 | 2;
};

export default useWebGLSupportLevel;
